import { TnAExtraHoursOverviewDTO, TnAExtraHoursOverviewSTO } from "../../models/tna-extra-hours-overviews";
import { BaseApiService } from "../base/base-api.service";

export class TnAExtraHoursOverviewsApiService extends BaseApiService<
  TnAExtraHoursOverviewDTO,
  TnAExtraHoursOverviewSTO
> {
  constructor() {
    super({
      servicePath: "/TnAOverviews",
      loadItemsPath: "/GetTnAExtraHoursOverviews",
    });
  }
}
